import styled from 'styled-components'

import { color } from 'styles/colors'
import { screenSize, SinglePanePage } from 'styles/shared'

const NotFound = () => {
  return (
    <SinglePanePage>
      <S.Title>404</S.Title>
      <S.Description>That page does not exist</S.Description>
    </SinglePanePage>
  )
}

export default NotFound

const S = {
  Title: styled.h1`
    text-align: center;
    margin-top: 1em;
    margin-bottom: .25em;
    font-size: 10em;
    color: ${color('watermarkTitle')};

    @media ${screenSize.small} {
      margin-top: .5em;
      font-size: 5em;
    }
  `,
  Description: styled.h2`
    text-align: center;
    font-size: 3em;
    color: ${color('watermarkDescription')};

    @media ${screenSize.small} {
      font-size: 1.5em;
    }
  `
}
